import React, { useState, useEffect } from "react";
import TimePicker from "./TimePicker";

const TimeEntry = ({ date, entryTime, exitTime, description, onChange }) => {
  const [localEntryTime, setLocalEntryTime] = useState(entryTime);
  const [localExitTime, setLocalExitTime] = useState(exitTime);
  const [localDescription, setLocalDescription] = useState(description);

  useEffect(() => {
    setLocalEntryTime(entryTime);
    setLocalExitTime(exitTime);
    setLocalDescription(description);
  }, [entryTime, exitTime, description]); // Dependências para atualizar o estado local

  const handleEntryTimeChange = (time) => {
    setLocalEntryTime(time);
    onChange({ date, entryTime: time, exitTime: localExitTime, description: localDescription });
  };

  const handleExitTimeChange = (time) => {
    setLocalExitTime(time);
    onChange({ date, entryTime: localEntryTime, exitTime: time, description: localDescription });
  };

  const handleDescriptionChange = (description) => {
    setLocalDescription(description);
    onChange({ date, entryTime: localEntryTime, exitTime: localExitTime, description });
  };

  const getWeekday = (dateStr) => {
    const dateObj = new Date(dateStr);
    return dateObj.toLocaleDateString("en-US", { weekday: "long" }); // Exemplo: "Monday"
  };

  const getTotalHours = () => {
    // Verifica se os objetos existem e têm as propriedades necessárias
    const isValidTime = (time) =>
      time &&
      typeof time === "object" &&
      time.hour &&
      time.minute &&
      time.period;
  
    if (!isValidTime(localEntryTime) || !isValidTime(localExitTime)) {
      return "—";
    }
  
    const parseTime = ({ hour, minute, period }) => {
      let h = parseInt(hour, 10);
      const m = parseInt(minute, 10);
  
      if (isNaN(h) || isNaN(m)) return null;
  
      if (period === "PM" && h !== 12) h += 12;
      if (period === "AM" && h === 12) h = 0;
  
      return h * 60 + m;
    };
  
    const entryTotal = parseTime(localEntryTime);
    const exitTotal = parseTime(localExitTime);
  
    if (entryTotal === null || exitTotal === null) return "—";
  
    let diff = exitTotal - entryTotal;
    if (diff < 0) diff += 24 * 60;
  
    const hours = Math.floor(diff / 60);
    const minutes = diff % 60;
  
    return `${hours}h ${minutes.toString().padStart(2, '0')}min`;
  };
  
  
  

  return (
    <div id={date} className="border border-gray-300 p-4 rounded-lg shadow-lg m-2 w-80 bg-white">
      <p className="text-lg font-semibold text-center text-gray-800  mb-3">{date} - <span style={{color: "#3271ff"}} >{getWeekday(date)}</span></p>
      <div className="flex flex-col items-center gap-4">
        <TimePicker label="Entry Time" time={localEntryTime} setTime={handleEntryTimeChange} />
        <TimePicker label="Exit Time" time={localExitTime} setTime={handleExitTimeChange} />
        <textarea
          value={localDescription}
          onChange={(e) => handleDescriptionChange(e.target.value)}
          placeholder="Add a description..."
          className="w-full p-2 border border-gray-300 rounded-md resize-none bg-gray-100 focus:ring focus:ring-blue-300"
          rows="3"
        />
      </div>
      <p className="mt-4 text-right text-sm text-gray-700">Total: {getTotalHours()}</p>
    </div>
  );
};

export default TimeEntry;